import type { Network } from "@saberhq/solana-contrib";

export const getQuarryDomainPrefix = (network: Network): string => {
  switch (network) {
    case "devnet":
      return `devnet.`;
    case "testnet":
      return `testnet.`;
    case "mainnet-beta":
    default:
      return `app.`;
  }
};

export const getQuarryOrigin = (network: Network): string =>
  `https://${getQuarryDomainPrefix(network)}quarry.so`;
